module.exports = __webpack_public_path__ + "static/media/warpath_screen_2.bffa912c.jpg";